import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';

import { ChatPageComponent } from './chat-page.component';

export function chatPathMatcher(url: UrlSegment[]) {
  const path = url && url[0] && url[0]['path'];

  if (path === 'chat') {
    return { consumed: url };
  }

  return null;
}

const routes: Routes = [
  {
    path: '',
    component: ChatPageComponent,
    data: {}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule {}
